import { BrowserRouter as Router, Routes, Route, } from 'react-router-dom';
import Home from './components/Home/home';
import About from './components/About/About';
import Gallery from './components/Gallery/Gallery';
import Explore from './components/Explore/Explore';
import Contact from './components/Contact/Contact';
import MidGallery from './components/Gallery/MidGallery';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import SmoothScrollWrapper from './helperComponents/SmoothScrollWrapper/SmoothScrollWrapper';


function App() {
  return (
    <div className="App">
      <Router>
        <SmoothScrollWrapper>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/loadgallery" element={<MidGallery />} />
            <Route path="/about" element={<About />} /> 
            <Route path="/explore" element={<Explore />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </SmoothScrollWrapper>
      </Router>
    </div>
  );
}

export default App;
